import * as React from 'react'

import Footer from 'main/components/common/Footer'
import { useWhitelabel } from 'main/framework'
import { AssetName } from 'main/util/asset'
import { IFilters, IRankingFactorWeights } from 'main/util/search'
import { SearchPage_result } from '../../gql'
import Content from './Content'
import { Container, ContentContainer, FooterContainer } from './ListingSection.styles'

interface IProps {
  error: boolean
  fetchingMore: boolean
  loading: boolean
  result: SearchPage_result | null
  filters: IFilters
  rankingFactorWeights: IRankingFactorWeights | null
  searchRadius: number
  usingRadius: boolean
  onChangeRankingWeights: (rankingWeights: IRankingFactorWeights) => void
  onChangeSearchRadius: (radius: number) => void
  onRequestNextPage: () => void
  regionSEOCopy: React.ReactNode | null
}

export default function ListingSection(props: IProps) {
  const showFooter = useWhitelabel().showByDefaultExceptIfFalse(AssetName.FOOTER)

  return (
    <Container>
      <ContentContainer>
        <Content {...props} />
        {props.regionSEOCopy}
      </ContentContainer>
      {showFooter && (
        <FooterContainer>
          <Footer />
        </FooterContainer>
      )}
    </Container>
  )
}
